export default __webpack_public_path__ + "fee564a321429e81681106813fd4b61b.png";